import { FileSignature, Download } from 'lucide-react';

export const AceptacionesHeader = () => {
    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between px-4 sm:px-7 py-4 border-b border-gray-200 bg-white gap-4 sm:gap-0 shrink-0">
            <div>
                <h1 className="flex items-center gap-2 m-0 text-lg sm:text-[19px] font-bold text-gray-900">
                    <FileSignature size={22} className="text-[#4f6df5]" strokeWidth={2} />
                    Registro de Aceptaciones
                </h1>
                <p className="mt-1 text-xs text-gray-500">Auditoría de consentimientos de términos, condiciones y contratos</p>
            </div>
            <div className="flex items-center w-full sm:w-auto">
                <button className="flex items-center justify-center w-full sm:w-auto px-4 py-2 text-xs font-semibold transition-all bg-white border rounded-lg border-gray-300 text-gray-700 hover:bg-gray-50 shadow-sm">
                    <Download size={14} className="mr-1.5" />
                    Exportar Registro
                </button>
            </div>
        </div>
    );
};